// 資格情報作成・編集画面
import React, { useState, useEffect, useCallback } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Grid,
  Theme,
  Divider,
  Button,
  Snackbar,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent
} from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import './List.css';
import { useHistory, Redirect, useLocation } from 'react-router-dom';
import 'date-fns';
import { useRecoilState } from 'recoil';
import { mainBlueColor, btnColor, isLoggedIn, userRole } from '../GlobalState';
import {
  getEmployeeCredentialsById,
  editEmployeeCredentials
} from '../apicalls/employeeMaster';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import LoadingComponent from '../components/LoadingComponent';
import { NotFoundPage } from './NotFoundPage';
import { EMPLOYEE_TYPE } from '../const/Const';
import { DatePickerInput } from '../components/atoms';
import { format } from 'date-fns';

// 資格情報の型定義
type LicenceInfo = {
  user_id: number;
  qualification_name: string;
  acquisition_date: string | null;
  renewal_date: string | null;
  expiration_date: string | null;
  qualification_type: string;
  remarks: string;
};
//  資格情報の初期状態
export const initialLicenceState: LicenceInfo = {
  user_id: 0,
  qualification_name: '',
  acquisition_date: null,
  renewal_date: null,
  expiration_date: null,
  qualification_type: '',
  remarks: ''
};

export const CreateEmployeeCredentialsInfo: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [userPermission, setUserPermission] = useRecoilState(userRole);
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  const [loading, setLoading] = useState(true);
  const [driverLicenseType, setDriverLicenseType] = useState(''); //運転免許の種類
  const [driverLicenseNumber, setDriverLicenseNumber] = useState(''); //運転免許番号
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);
  const [deleteTargetIndex, setDeleteTargetIndex] =
    useState<number | null>(null);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const matches2 = useMediaQuery('(min-width:900px)');

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll'
      },
      paper: {
        width: matches2 ? 600 : '80%'
      },

      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        height: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },

      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 80,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 80,
        alignItems: 'center'
      },
      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        height: 60,
        maxHeight: 100,
        width: '100%'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        height: 48,
        width: '100%'
      },
      topList: {
        display: 'flex',
        marginTop: 25,
        width: '100%',
        justifyContent: 'flex-start'
      },
      topColumn: {
        fontSize: 16,
        color: '#000000'
      },
      topBoxText: {
        fontSize: 14,
        color: '#000000'
      },
      editButtonMobile: {
        alignSelf: 'center',
        margin: 5
      }
    })
  );

  const classes = useStyles();
  const history: any = useHistory();
  const location: any = useLocation();

  // 自社社員か社外パートナーか
  const employeeType: number = history.location.state.employeeType;
  // 社員ID
  const employeeId: number = history.location.state.employeeId;

  // 社員の資格情報を取得
  const getAllDetailsOfEmployeeMasterById = () => {
    getEmployeeCredentialsById(employeeId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setDriverLicenseType(data.data.driver_license_type || '');
            setDriverLicenseNumber(data.data.driver_license_number || '');

            if (data.data.licences && data.data.licences.length > 0) {
              const formattedLicences = data.data.licences.map(
                (licence: LicenceInfo) => ({
                  ...licence,
                  user_id: employeeId,
                  qualification_name: licence.qualification_name || '',
                  qualification_type: licence.qualification_type || '',
                  remarks: licence.remarks || '',
                  // 日付の処理を修正
                  acquisition_date: licence.acquisition_date
                    ? new Date(licence.acquisition_date)
                    : null,
                  renewal_date: licence.renewal_date
                    ? new Date(licence.renewal_date)
                    : null,
                  expiration_date: licence.expiration_date
                    ? new Date(licence.expiration_date)
                    : null
                })
              );
              setLicenses(formattedLicences);
            } else {
              setLicenses([
                {
                  user_id: employeeId,
                  qualification_name: '',
                  acquisition_date: null,
                  renewal_date: null,
                  expiration_date: null,
                  qualification_type: '',
                  remarks: ''
                }
              ]);
            }

            setLoading(false);
          }
        }
      }
    });
  };

  // 保存処理
  const editEmployeeCredentialsDetails = () => {
    // バリデーション
    const validationErrors = [];

    licenses.forEach((license, index) => {
      if (
        license.qualification_name &&
        license.qualification_name.length > 60
      ) {
        validationErrors.push(
          `資格名${index + 1}は60文字以内で入力してください。`
        );
      }
      if (
        license.qualification_type &&
        license.qualification_type.length > 60
      ) {
        validationErrors.push(
          `資格種別${index + 1}は60文字以内で入力してください。`
        );
      }
      if (license.remarks && license.remarks.length > 225) {
        validationErrors.push(
          `備考${index + 1}は225文字以内で入力してください。`
        );
      }
    });

    if (driverLicenseNumber && driverLicenseNumber.length > 20) {
      validationErrors.push('運転免許番号は20文字以内で入力してください。');
    }

    if (validationErrors.length > 0) {
      setErrorMessage(validationErrors.join('\n'));
      setOpen(true);
      return;
    }

    // データの整形
    const formattedFields = licenses.map(license => {
      return {
        user_id: employeeId,
        qualification_name: license.qualification_name,
        qualification_type: license.qualification_type,
        remarks: license.remarks,
        acquisition_date: license.acquisition_date
          ? format(new Date(license.acquisition_date), 'yyyy-MM-dd')
          : null,
        renewal_date: license.renewal_date
          ? format(new Date(license.renewal_date), 'yyyy-MM-dd')
          : null,
        expiration_date: license.expiration_date
          ? format(new Date(license.expiration_date), 'yyyy-MM-dd')
          : null
      };
    });

    editEmployeeCredentials(
      employeeId,
      driverLicenseType,
      driverLicenseNumber,
      formattedFields
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
          }
        }
      }
    });
  };

  useEffect(() => {
    getAllDetailsOfEmployeeMasterById();
  }, []);

  // 資格情報フィールドセットの管理
  const [licenses, setLicenses] = useState<LicenceInfo[]>([
    {
      user_id: employeeId,
      qualification_name: '',
      acquisition_date: null,
      renewal_date: null,
      expiration_date: null,
      qualification_type: '',
      remarks: ''
    }
  ]);

  // 資格情報フィールドセットの追加
  const addFieldSet = () => {
    setLicenses([
      ...licenses,
      {
        user_id: employeeId,
        qualification_name: '',
        acquisition_date: null,
        renewal_date: null,
        expiration_date: null,
        qualification_type: '',
        remarks: ''
      }
    ]);
  };

  // 削除確認モーダルを開く
  const handleClickOpenDeleteAlert = (index: number) => {
    setDeleteTargetIndex(index);
    setOpenDeleteAlert(true);
  };

  // 削除確認モーダルを閉じる
  const handleCloseDeleteAlert = () => {
    setOpenDeleteAlert(false);
    setDeleteTargetIndex(null);
  };

  // 資格削除処理
  const handleDelete = () => {
    if (deleteTargetIndex !== null && deleteTargetIndex > 0) {
      setLicenses(licenses.filter((_, i) => i !== deleteTargetIndex));
    }
    handleCloseDeleteAlert();
  };

  // フィールド値の更新
  const handleFieldChange = (
    index: number,
    field: keyof LicenceInfo,
    value: string | Date | null
  ) => {
    const newLicenses = [...licenses];
    newLicenses[index] = {
      ...newLicenses[index],
      [field]: value
    };
    setLicenses(newLicenses);
  };

  // パンくずリスト表示パターン(編集)
  let patternName =
    employeeType === EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
      ? 'employee_masters_edit'
      : 'outside_partnerem_edit';

  // 新規作成画面のモードの場合
  if (location.pathname.match('create')) {
    // パンくずリスト表示パターン(新規)
    patternName =
      employeeType === EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
        ? 'employee_masters_create'
        : 'outside_partnerem_create';
  }

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  if (userPermission === 2 || userPermission === 3) {
    return <NotFoundPage />;
  }

  return (
    <>
      <AppBarComponent patternName={patternName} />

      {loading || userPermission === undefined ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <>
          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#F5F5F5',
              minHeight: window.innerHeight - 150
            }}
          >
            <div style={{ margin: 15 }}>
              <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
              >
                <Alert onClose={handleClose} severity='error'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openSuccess}
                autoHideDuration={4000}
                onClose={handleCloseSuccess}
              >
                <Alert onClose={handleCloseSuccess} severity='success'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              {employeeType === EMPLOYEE_TYPE['OUTSIDE_PARTNER'] && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <Button
                    style={{
                      minWidth: 90,
                      marginRight: 15,
                      marginBottom: 20,
                      color: '#758283',
                      backgroundColor: '#F5F5F5'
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                      // 業者詳細に戻る
                      if (history.location.state.partnerId) {
                        history.goBack();
                      }
                      // 社外パートナー一覧に戻る
                      history.push('/employee-masters', {
                        employeeType: employeeType
                      });
                    }}
                    startIcon={<ArrowBackIcon />}
                  >
                    戻る
                  </Button>
                </div>
              )}

              <div>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    {employeeType === EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
                      ? '社員基本情報'
                      : '社外パートナー基本情報'}
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: matches2 ? 'row' : 'column'
                  }}
                  className={classes.topList}
                >
                  <div
                    // 空アイテム
                    className='empty-list'
                    style={{ width: 15 }}
                  ></div>
                  <div
                    onClick={() => {
                      if (history.location.state?.employeeId) {
                        history.push(`/employee-masters/${employeeId}/edit`, {
                          employeeId: employeeId,
                          actionType: 'edit',
                          employeeType: employeeType
                        });
                      }
                    }}
                    className='border2'
                  >
                    <div className={classes.topBoxText}>基本情報</div>
                  </div>
                  <div
                    onClick={() => {
                      if (history.location.state?.employeeId) {
                        history.push(
                          `/employee-health-info/${employeeId}/edit`,
                          {
                            employeeId: employeeId,
                            actionType: 'edit',
                            employeeType: employeeType
                          }
                        );
                      }
                    }}
                    className='border2'
                  >
                    <div className={classes.topBoxText}>健康状態</div>
                  </div>
                  <div
                    onClick={() => {
                      if (history.location.state?.employeeId) {
                        history.push(
                          `/employee-emergency-info/${employeeId}/edit`,
                          {
                            employeeId: employeeId,
                            actionType: 'edit',
                            employeeType: employeeType
                          }
                        );
                      }
                    }}
                    className='border2'
                  >
                    <div className={classes.topBoxText}>緊急連絡先情報</div>
                  </div>
                  <div
                    className='border2'
                    style={{
                      backgroundColor: '#F5F5F5',
                      borderTopColor: '#0099CB',
                      borderBottom: 'none'
                    }}
                  >
                    <div
                      className={classes.topBoxText}
                      style={{ color: '#0099CB' }}
                    >
                      資格情報
                    </div>
                  </div>
                </div>

                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 5,
                      fontSize: 24
                    }}
                  >
                    {'資格情報'}
                  </div>
                  <Button
                    style={{
                      marginTop: 20,
                      marginRight: 20,
                      color: '#FFFFFF',
                      backgroundColor: '#007dff',
                      marginBottom: !matches2 ? 10 : 0
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={addFieldSet}
                    startIcon={<NoteAddIcon />}
                  >
                    資格を追加
                  </Button>
                </div>
                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingBottom: 15,
                    marginBottom: 15
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      overflowX: 'auto',
                      padding: '0 15px'
                    }}
                  >
                    <div style={{ display: 'flex', minWidth: '100%' }}>
                      {licenses.map((license, index) => (
                        <div
                          key={index}
                          style={{ minWidth: 550, marginRight: 20 }}
                        >
                          {/* 資格名 */}
                          <div>
                            <Divider
                              style={{
                                backgroundColor: '#CCCCCC',
                                marginLeft: 15
                              }}
                            />
                            <div className={classes.subContainer}>
                              <div className={classes.textMainContainer}>
                                <div className={classes.textContainer}>
                                  資格名
                                </div>
                              </div>
                              <div className={classes.inputMainContainer}>
                                <div className={classes.inputContainer}>
                                  <input
                                    name='qualification_name'
                                    value={license.qualification_name}
                                    maxLength={20}
                                    onChange={event =>
                                      handleFieldChange(
                                        index,
                                        'qualification_name',
                                        event.target.value
                                      )
                                    }
                                    className={classes.input}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* 取得日 */}
                          <div>
                            <Divider
                              style={{
                                backgroundColor: '#CCCCCC',
                                marginLeft: 15
                              }}
                            />
                            <div className={classes.subContainer}>
                              <div className={classes.textMainContainer}>
                                <div className={classes.textContainer}>
                                  取得日
                                </div>
                              </div>
                              <div className={classes.inputMainContainer}>
                                <div
                                  style={{
                                    marginLeft: 10,
                                    marginRight: 15,
                                    backgroundColor: '#FFFFFF',
                                    height: 42,
                                    paddingBottom: 5,
                                    paddingLeft: 5,
                                    width: '100%'
                                  }}
                                  className={'select-div-div'}
                                >
                                  <DatePickerInput
                                    date={
                                      license.acquisition_date
                                        ? new Date(license.acquisition_date)
                                        : null
                                    }
                                    onChange={date =>
                                      handleFieldChange(
                                        index,
                                        'acquisition_date',
                                        date
                                      )
                                    }
                                    id={`acquisition_date_${index}`}
                                    emptyLabel={'日付を選択'}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* 更新日 */}
                          <div>
                            <Divider
                              style={{
                                backgroundColor: '#CCCCCC',
                                marginLeft: 15
                              }}
                            />
                            <div className={classes.subContainer}>
                              <div className={classes.textMainContainer}>
                                <div className={classes.textContainer}>
                                  更新日
                                </div>
                              </div>
                              <div className={classes.inputMainContainer}>
                                <div
                                  style={{
                                    marginLeft: 10,
                                    marginRight: 15,
                                    backgroundColor: '#FFFFFF',
                                    height: 42,
                                    paddingBottom: 5,
                                    paddingLeft: 5,
                                    width: '100%'
                                  }}
                                  className={'select-div-div'}
                                >
                                  <DatePickerInput
                                    date={
                                      license.renewal_date
                                        ? new Date(license.renewal_date)
                                        : null
                                    }
                                    onChange={date =>
                                      handleFieldChange(
                                        index,
                                        'renewal_date',
                                        date
                                      )
                                    }
                                    id={`renewal_date_${index}`}
                                    emptyLabel={'日付を選択'}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* 失効日 */}
                          <div>
                            <Divider
                              style={{
                                backgroundColor: '#CCCCCC',
                                marginLeft: 15
                              }}
                            />
                            <div className={classes.subContainer}>
                              <div className={classes.textMainContainer}>
                                <div className={classes.textContainer}>
                                  失効日
                                </div>
                              </div>
                              <div className={classes.inputMainContainer}>
                                <div
                                  style={{
                                    marginLeft: 10,
                                    marginRight: 15,
                                    backgroundColor: '#FFFFFF',
                                    height: 42,
                                    paddingBottom: 5,
                                    paddingLeft: 5,
                                    width: '100%'
                                  }}
                                  className={'select-div-div'}
                                >
                                  <DatePickerInput
                                    date={
                                      license.expiration_date
                                        ? new Date(license.expiration_date)
                                        : null
                                    }
                                    onChange={date =>
                                      handleFieldChange(
                                        index,
                                        'expiration_date',
                                        date
                                      )
                                    }
                                    id={`expiration_date_${index}`}
                                    emptyLabel={'日付を選択'}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* 資格種別 */}
                          <div>
                            <Divider
                              style={{
                                backgroundColor: '#CCCCCC',
                                marginLeft: 15
                              }}
                            />
                            <div className={classes.subContainer}>
                              <div className={classes.textMainContainer}>
                                <div className={classes.textContainer}>
                                  資格種別
                                </div>
                              </div>
                              <div className={classes.inputMainContainer}>
                                <div className={classes.inputContainer}>
                                  <input
                                    name='qualification_type'
                                    value={license.qualification_type}
                                    maxLength={60} // 60文字制限に修正
                                    onChange={event =>
                                      handleFieldChange(
                                        index,
                                        'qualification_type',
                                        event.target.value
                                      )
                                    }
                                    className={classes.input}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* 備考 */}
                          <div>
                            <Divider
                              style={{
                                backgroundColor: '#CCCCCC',
                                marginLeft: 15
                              }}
                            />
                            <div className={classes.subContainer}>
                              <div className={classes.textMainContainer}>
                                <div className={classes.textContainer}>
                                  備考
                                </div>
                              </div>
                              <div className={classes.inputMainContainer}>
                                <div className={classes.inputContainer}>
                                  <input
                                    name='remarks'
                                    value={license.remarks}
                                    maxLength={225} // 225文字制限に修正
                                    onChange={event =>
                                      handleFieldChange(
                                        index,
                                        'remarks',
                                        event.target.value
                                      )
                                    }
                                    className={classes.input}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* 削除確認モーダルを追加 */}
                          <Dialog
                            open={openDeleteAlert}
                            onClose={handleCloseDeleteAlert}
                            aria-labelledby='alert-dialog-title'
                            aria-describedby='alert-dialog-description'
                            BackdropProps={{
                              style: {
                                backgroundColor: 'rgba(0, 0, 0, 0.1)'
                              }
                            }}
                            PaperProps={{
                              style: {
                                boxShadow: '0px 3px 15px rgba(0, 0, 0, 0.1)'
                              }
                            }}
                          >
                            <DialogTitle id='alert-dialog-title'>
                              {'削除しますか？'}
                            </DialogTitle>
                            <DialogActions>
                              <Button
                                onClick={handleCloseDeleteAlert}
                                color='primary'
                              >
                                キャンセル
                              </Button>
                              <Button
                                onClick={handleDelete}
                                color='primary'
                                autoFocus
                              >
                                削除
                              </Button>
                            </DialogActions>
                          </Dialog>
                          <div>
                            <Divider
                              style={{
                                backgroundColor: '#CCCCCC',
                                marginLeft: 15
                              }}
                            />
                            {index > 0 && (
                              <div
                                style={{
                                  textAlign: 'right',
                                  marginTop: 10,
                                  marginBottom: 10
                                }}
                              >
                                <Button
                                  style={{
                                    color: '#758283',
                                    backgroundColor: '#F5F5F5'
                                  }}
                                  variant='contained'
                                  color='secondary'
                                  onClick={() =>
                                    handleClickOpenDeleteAlert(index)
                                  }
                                  startIcon={<DeleteIcon />}
                                >
                                  削除
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Grid>

                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 5,
                      fontSize: 24
                    }}
                  >
                    {'取得技術・受講講習情報等'}
                  </div>
                </div>
                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingBottom: 15,
                    marginBottom: 15
                  }}
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          運転免許の種類
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <select
                            value={driverLicenseType}
                            onChange={e => {
                              setDriverLicenseType(e.target.value);
                            }}
                            className={classes.selectBoxStyle}
                          >
                            <option value=''>選択してください</option>
                            <option value='普通自動車運転免許(第1種)'>
                              普通自動車運転免許(第1種)
                            </option>
                            <option value='普通自動車運転免許(第1種) AT限定'>
                              普通自動車運転免許(第1種) AT限定
                            </option>
                            <option value='保有なし'>保有なし</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          運転免許番号
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={driverLicenseNumber}
                            onChange={text => {
                              setDriverLicenseNumber(text.target.value);
                            }}
                            className={classes.input}
                            maxLength={20}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
            <div style={{ height: 80 }} />
          </div>

          <div
            className='save-btn-container'
            style={{
              backgroundColor: '#FFFFFF',
              position: 'fixed',
              bottom: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'space-around',
              padding: 20
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Button
                onClick={() => {
                  editEmployeeCredentialsDetails();
                }}
                style={{
                  paddingLeft: 50,
                  paddingRight: 50,
                  backgroundColor: buttonColor
                }}
                variant='contained'
                color='primary'
              >
                保存
              </Button>
            </div>
          </div>
        </>
      )}
    </>
  );
};
